import { Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer.jsx";

const MainLayout = () => {
  const navigation = useNavigate();       

  return (
    <div className="min-h-screen bg-white dark:bg-gray-950 transition-colors duration-300">
      <div className="fixed top-0 left-0 w-full z-50">
        <Navbar />
      </div>
      <div className="w-full pt-16 flex flex-col min-h-screen">
        <div className="page-animate flex-1">
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;